// This file is auto-generated

import * as grpcWeb from 'grpc-web';
import { Message } from "google-protobuf";
import { GrpcWebClient, GrpcWebMethodDesc } from '../util/grpc.client';

import * as model from "./account";
import * as dep_1 from "./../google/protobuf/empty";
import * as dep_2 from "./user";

export class AccountServiceClient<META = grpcWeb.Metadata> extends GrpcWebClient<META> {

    static methodLogin = new GrpcWebMethodDesc(
        '/myedvenn.account.AccountService/Login',
        grpcWeb.MethodType.UNARY,
        model.MPostLogin,
        model.MAccount,
        model.MPostLogin.serializeBinary,
        model.MPostLogin.deserializeBinary,
        model.MAccount.serializeBinary,
        model.MAccount.deserializeBinary
    )

    login(request: model.IPostLogin, metadata?: META): Promise<model.Account>;
    login(request: model.IPostLogin, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: model.MAccount) => void): grpcWeb.ClientReadableStream<model.MAccount>;
    login(request: model.IPostLogin, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: model.MAccount) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + AccountServiceClient.methodLogin.getName(),
                request instanceof Message ? request as model.MPostLogin : new model.MPostLogin(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodLogin as grpcWeb.MethodDescriptor<model.MPostLogin, model.MAccount>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + AccountServiceClient.methodLogin.getName(),
                request instanceof Message ? request as model.MPostLogin : new model.MPostLogin(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodLogin as grpcWeb.MethodDescriptor<model.MPostLogin, model.MAccount>
            ).then(x => x.toObject());
    }

    static methodLogout = new GrpcWebMethodDesc(
        '/myedvenn.account.AccountService/Logout',
        grpcWeb.MethodType.UNARY,
        dep_1.MEmpty,
        dep_1.MEmpty,
        dep_1.MEmpty.serializeBinary,
        dep_1.MEmpty.deserializeBinary,
        dep_1.MEmpty.serializeBinary,
        dep_1.MEmpty.deserializeBinary
    )

    logout(request: dep_1.IEmpty, metadata?: META): Promise<dep_1.Empty>;
    logout(request: dep_1.IEmpty, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: dep_1.MEmpty) => void): grpcWeb.ClientReadableStream<dep_1.MEmpty>;
    logout(request: dep_1.IEmpty, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: dep_1.MEmpty) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + AccountServiceClient.methodLogout.getName(),
                request instanceof Message ? request as dep_1.MEmpty : new dep_1.MEmpty(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodLogout as grpcWeb.MethodDescriptor<dep_1.MEmpty, dep_1.MEmpty>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + AccountServiceClient.methodLogout.getName(),
                request instanceof Message ? request as dep_1.MEmpty : new dep_1.MEmpty(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodLogout as grpcWeb.MethodDescriptor<dep_1.MEmpty, dep_1.MEmpty>
            ).then(x => x.toObject());
    }

    static methodGetMe = new GrpcWebMethodDesc(
        '/myedvenn.account.AccountService/GetMe',
        grpcWeb.MethodType.UNARY,
        dep_1.MEmpty,
        model.MAccount,
        dep_1.MEmpty.serializeBinary,
        dep_1.MEmpty.deserializeBinary,
        model.MAccount.serializeBinary,
        model.MAccount.deserializeBinary
    )

    getMe(request: dep_1.IEmpty, metadata?: META): Promise<model.Account>;
    getMe(request: dep_1.IEmpty, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: model.MAccount) => void): grpcWeb.ClientReadableStream<model.MAccount>;
    getMe(request: dep_1.IEmpty, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: model.MAccount) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + AccountServiceClient.methodGetMe.getName(),
                request instanceof Message ? request as dep_1.MEmpty : new dep_1.MEmpty(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodGetMe as grpcWeb.MethodDescriptor<dep_1.MEmpty, model.MAccount>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + AccountServiceClient.methodGetMe.getName(),
                request instanceof Message ? request as dep_1.MEmpty : new dep_1.MEmpty(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodGetMe as grpcWeb.MethodDescriptor<dep_1.MEmpty, model.MAccount>
            ).then(x => x.toObject());
    }

    static methodChangePassword = new GrpcWebMethodDesc(
        '/myedvenn.account.AccountService/ChangePassword',
        grpcWeb.MethodType.UNARY,
        model.MPostChangePassword,
        dep_1.MEmpty,
        model.MPostChangePassword.serializeBinary,
        model.MPostChangePassword.deserializeBinary,
        dep_1.MEmpty.serializeBinary,
        dep_1.MEmpty.deserializeBinary
    )

    changePassword(request: model.IPostChangePassword, metadata?: META): Promise<dep_1.Empty>;
    changePassword(request: model.IPostChangePassword, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: dep_1.MEmpty) => void): grpcWeb.ClientReadableStream<dep_1.MEmpty>;
    changePassword(request: model.IPostChangePassword, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: dep_1.MEmpty) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + AccountServiceClient.methodChangePassword.getName(),
                request instanceof Message ? request as model.MPostChangePassword : new model.MPostChangePassword(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodChangePassword as grpcWeb.MethodDescriptor<model.MPostChangePassword, dep_1.MEmpty>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + AccountServiceClient.methodChangePassword.getName(),
                request instanceof Message ? request as model.MPostChangePassword : new model.MPostChangePassword(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodChangePassword as grpcWeb.MethodDescriptor<model.MPostChangePassword, dep_1.MEmpty>
            ).then(x => x.toObject());
    }

    static methodChangeMyPassword = new GrpcWebMethodDesc(
        '/myedvenn.account.AccountService/ChangeMyPassword',
        grpcWeb.MethodType.UNARY,
        model.MPostChangeMyPassword,
        dep_1.MEmpty,
        model.MPostChangeMyPassword.serializeBinary,
        model.MPostChangeMyPassword.deserializeBinary,
        dep_1.MEmpty.serializeBinary,
        dep_1.MEmpty.deserializeBinary
    )

    changeMyPassword(request: model.IPostChangeMyPassword, metadata?: META): Promise<dep_1.Empty>;
    changeMyPassword(request: model.IPostChangeMyPassword, metadata: META | undefined, callback: (err: grpcWeb.RpcError, response: dep_1.MEmpty) => void): grpcWeb.ClientReadableStream<dep_1.MEmpty>;
    changeMyPassword(request: model.IPostChangeMyPassword, metadata = {} as META, callback?: (err: grpcWeb.RpcError, response: dep_1.MEmpty) => void) {
        this.callInterceptors.forEach(_c => _c.intercept(request, metadata));

        return (callback !== undefined) ?
             this.client.rpcCall(
                this.hostname + AccountServiceClient.methodChangeMyPassword.getName(),
                request instanceof Message ? request as model.MPostChangeMyPassword : new model.MPostChangeMyPassword(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodChangeMyPassword as grpcWeb.MethodDescriptor<model.MPostChangeMyPassword, dep_1.MEmpty>,
                callback
            )
            :
            this.client.thenableCall(
                this.hostname + AccountServiceClient.methodChangeMyPassword.getName(),
                request instanceof Message ? request as model.MPostChangeMyPassword : new model.MPostChangeMyPassword(request),
                metadata as grpcWeb.Metadata,
                AccountServiceClient.methodChangeMyPassword as grpcWeb.MethodDescriptor<model.MPostChangeMyPassword, dep_1.MEmpty>
            ).then(x => x.toObject());
    }

}

                        
export default () => {}